import PageHead from "@/components/PageHead";
import LegalLayout from "@/components/LegalLayout";
import termsMd from "@/content/legal/terms.md?raw";

export default function Terms() {
  return (
    <>
      <PageHead
        title="Terms & Conditions | WeKIT™ Career Clarity 360"
        description="The terms governing your use of WeKIT™.ai — accounts, payments, AI tools, mentorship, and acceptable use."
        path="/terms"
      />
      <LegalLayout markdown={termsMd} />
    </>
  );
}
